export default __webpack_public_path__ + "static/media/marthi-rama-brahman.ac6c7251.png";